export default [
    '$window',
    ($window) => {
        return function (input) {
            if (input && (input.startsWith('http') || input.startsWith('inshort') || input.startsWith('ithoughts'))) {
                return $window.encodeURI(input.split(/\r?\n/, 1));
            } else if (input) {
                return $window.encodeURIComponent(input);
            } else {
                return input;
            }
        };
    },
];
